/**
 * A row action, as an icon.
 *
 * The template puts row actions behind a `⋮` menu. Two actions do not earn a menu — that is one
 * click to reveal what fits in the space the menu button itself occupies, and on a list an
 * operator works through row by row it is one click per row. The menu earns its place at four or
 * more; until then the actions are just there.
 *
 * `label` names the record, not the verb. Nine identical "Edit" buttons is what a screen-reader
 * user hears otherwise, with no way to tell which row they are on.
 */
export function IconAction({
  icon,
  label,
  disabled = false,
  onClick,
}: {
  icon: string;
  label: string;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="inline-flex size-7 cursor-pointer items-center justify-center rounded-md border border-border-color bg-white text-gray-600 hover:bg-light hover:text-gray-900 disabled:cursor-not-allowed disabled:opacity-40"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      <i className={`${icon} text-[13px]`} />
    </button>
  );
}
